/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import Select from 'components/Select.jsx';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import EventTracking from 'lib/EventTracking';
import Glyph from 'components/Glyph.jsx';

import './styles/SubjectPicker.scss';

type Props = {
  initialSubject: ?string,
  onChange: (subject: ?string) => void,
  subjects: Object[],
};

type State = {
  selectedSubject: ?string,
};

export class SubjectPicker extends React.Component<Props, State> {
  state: State = {
    selectedSubject: this.props.initialSubject,
  };

  static contextTypes = {
    eventScreenName: PropTypes.string,
  };

  setSubject = (subject: string) => {
    this.setState({ selectedSubject: subject });
    this.props.onChange(subject);
    EventTracking.tap(this.context.eventScreenName || 'subject_picker', 'save_subject', {
      subject,
    });
  };
  render() {
    const subjects = this.props.subjects.map(s => ({ value: s.subject_code, label: s.name }));

    return (
      <div className="SubjectPicker">
        <Glyph className="SubjectPicker-glyph" color="eclipse" name="search" size="small" />
        <Select
          className="SubjectPicker-select"
          options={subjects}
          onChange={this.setSubject}
          value={this.state.selectedSubject}
          searchable
        />
      </div>
    );
  }
}

const withSubjects = graphql(
  gql`
    query SubjectPicker {
      settings {
        class {
          subjects {
            subject_code
            name
          }
        }
      }
    }
  `,
  {
    props: ({ data }) => ({
      subjects: data.settings ? data.settings.class.subjects : [],
    }),
  }
);

export default withSubjects(SubjectPicker);
